import React from 'react';
import styled from 'styled-components';
import classnames from 'classnames';

import LabeledContent from 'shared/components/LabeledContent';
import { LabeledContentProps } from 'shared/components/LabeledContent/types';

const LABEL_CLASS_NAME = 'flow-labeled-content__label';

const StyledLabeledContent = styled(LabeledContent)`
  & .${LABEL_CLASS_NAME} {
    color: #8d9199;
    font-size: 1rem;
  }
`;

// TODO: This is just a wrapper to avoid styling the label of `LabeledContent` every time it is used.
// Check if this an overkill.
const FlowLabeledContent = ({
  children,
  labelClassName,
  ...otherProps
}: LabeledContentProps) => (
  <StyledLabeledContent
    {...otherProps}
    labelClassName={classnames(LABEL_CLASS_NAME, labelClassName)}
  >
    {children}
  </StyledLabeledContent>
);

export default FlowLabeledContent;
